module.exports = __webpack_public_path__ + "img/apoyo-tecnico.3f5b4bfa.svg";